function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import { withMedia, MediaQueryProvider } from 'react-media-query-hoc';
import { PropertyType } from '@domain-group/fe-allhomes-library';
import AllhomesWatchlistButton from '@domain-group/fe-co-allhomes-watchlist-button';
import { withEventBoundary, useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import { BtrPill as BtrPillBase } from '@domain-group/fe-co-allhomes-shared-components';
import { OnlineAuctionIcon } from '@domain-group/fe-co-icon';
import { CommercialFeatureIcons, VitalStatistics, FeatureIcons, featureIconsPropTypes, ListingDescription, PropertyIdentifier, PropertyIdentifierAppearance, addressPropTypes } from './components';
import * as styles from './allhomes-listing-summary.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ListingSummary = styles.ListingSummary,
  Title = styles.Title;
var BtrPill = _ref => {
  var _property$development;
  var property = _ref.property;
  return ___EmotionJSX(React.Fragment, null, ((_property$development = property.development) === null || _property$development === void 0 ? void 0 : _property$development.type) === 'RENTAL' && ___EmotionJSX("div", {
    css: styles.btrPillContainer
  }, ___EmotionJSX(BtrPillBase, null)));
};
BtrPill.propTypes = {
  property: PropTypes.shape({
    development: PropTypes.shape({
      type: PropTypes.oneOf(['SALE', 'RENTAL'])
    })
  }).isRequired
};
var AllhomesListingSummary = props => {
  var _props$features$sizes, _props$features$sizes2, _props$features$sizes3, _props$property, _props$property$listi, _props$property$listi2, _props$sizes, _props$sizes2, _props$sizes3;
  var _props$media = props.media,
    desktop = _props$media.desktop,
    tablet = _props$media.tablet,
    mobile = _props$media.mobile;
  var previewHeight = desktop ? props.previewHeightDesktop : props.previewHeightMobile;
  var isResidential = props.appearance === PropertyIdentifierAppearance.RESIDENTIAL;
  var isCommercial = props.appearance === PropertyIdentifierAppearance.COMMERCIAL;
  var isEarlyAccess = props.appearance === PropertyIdentifierAppearance.EARLY_ACCESS;
  var isNewDevParent = props.appearance === PropertyIdentifierAppearance.NEW_DEVELOPMENT;
  var hasFeatures = props.propertyType || ['beds', 'baths', 'ensuite', 'garage', 'carport', 'parking'].some(item => props.features[item] !== 0) || ((_props$features$sizes = props.features.sizes) === null || _props$features$sizes === void 0 ? void 0 : _props$features$sizes.floor) || props.unimprovedValue || ((_props$features$sizes2 = props.features.sizes) === null || _props$features$sizes2 === void 0 ? void 0 : _props$features$sizes2.building) || ((_props$features$sizes3 = props.features.sizes) === null || _props$features$sizes3 === void 0 ? void 0 : _props$features$sizes3.block);
  var hasOnlineAuction = (_props$property = props.property) === null || _props$property === void 0 ? void 0 : (_props$property$listi = _props$property.listing) === null || _props$property$listi === void 0 ? void 0 : (_props$property$listi2 = _props$property$listi.auctions) === null || _props$property$listi2 === void 0 ? void 0 : _props$property$listi2.some(each => each.hasOnlineAuction);
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var onlineAuctionCTA = () => ___EmotionJSX(Button, {
    appearance: "accent",
    icon: ___EmotionJSX(OnlineAuctionIcon, null),
    css: styles.onlineAuction,
    onClick: () => {
      props.scrollToAuction();
      sendEvent('online-auction-primary-cta-click');
    }
  }, "Online auction available - learn more");
  if (isNewDevParent) {
    return ___EmotionJSX(ListingSummary, {
      "data-testid": "summary"
    }, ___EmotionJSX(BtrPill, {
      property: props.property
    }), ___EmotionJSX(PropertyIdentifier, {
      property: props.property,
      price: props.price,
      address: props.address,
      appearance: props.appearance,
      headline: props.development.name,
      tagline: props.development.tagline,
      onLogoClicked: props.onLogoClicked
    }));
  }
  return ___EmotionJSX(ListingSummary, {
    "data-testid": "summary"
  }, desktop && props.enableWatchlistButton && ___EmotionJSX(AllhomesWatchlistButton, {
    css: styles.watchlist,
    onAddToWatchlist: props.onAddToWatchlist,
    listingId: props.listingId
  }), ___EmotionJSX(BtrPill, {
    property: props.property
  }), ___EmotionJSX(PropertyIdentifier, {
    property: props.property,
    price: props.price,
    address: props.address,
    appearance: props.appearance,
    headline: props.title,
    agencyLogos: props.agencyLogos,
    onLogoClicked: props.onLogoClicked
  }), !mobile && hasOnlineAuction && onlineAuctionCTA(), ___EmotionJSX("div", {
    css: styles.statsContainer(hasFeatures)
  }, isCommercial ? ___EmotionJSX(CommercialFeatureIcons, {
    size: (_props$sizes = props.sizes) === null || _props$sizes === void 0 ? void 0 : _props$sizes.floor,
    propertyType: props.propertyType,
    additionalPropertyTypes: props.additionalPropertyTypes
  }) : ___EmotionJSX(FeatureIcons, _extends({}, props.features, {
    unimprovedValue: props.unimprovedValue,
    propertyType: mobile && !isEarlyAccess ? null : props.propertyType,
    priceGuide: props.priceGuide
  })), mobile && hasOnlineAuction && onlineAuctionCTA(), (!mobile || isEarlyAccess) && ___EmotionJSX(VitalStatistics, {
    propertyType: props.propertyType,
    shortLabels: tablet,
    blockSize: (_props$sizes2 = props.sizes) === null || _props$sizes2 === void 0 ? void 0 : _props$sizes2.block,
    buildingSize: (_props$sizes3 = props.sizes) === null || _props$sizes3 === void 0 ? void 0 : _props$sizes3.building,
    unimprovedValue: props.unimprovedValue,
    floor: props.floor
  })), props.preDescription, isResidential && ___EmotionJSX(Title, {
    as: "h3"
  }, props.title), ___EmotionJSX(ListingDescription, {
    featureList: props.featureList,
    previewHeight: previewHeight,
    listingId: props.listingId,
    description: props.description,
    onResizeFinished: props.onResizeFinished,
    clientRendered: props.clientRenderedDescription
  }), props.children);
};
AllhomesListingSummary.propTypes = _objectSpread(_objectSpread({
  listingId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  propertyType: PropTypes.oneOf(Object.keys(PropertyType)).isRequired,
  additionalPropertyTypes: PropTypes.arrayOf(PropTypes.oneOf(Object.keys(PropertyType))),
  price: PropTypes.string,
  priceGuide: PropTypes.string,
  appearance: PropTypes.oneOf(Object.keys(PropertyIdentifierAppearance)),
  title: PropTypes.string,
  address: PropTypes.shape(addressPropTypes).isRequired,
  description: PropTypes.string,
  features: PropTypes.shape(featureIconsPropTypes).isRequired,
  sizes: PropTypes.shape({
    floor: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    building: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    block: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  development: PropTypes.shape({
    name: PropTypes.string,
    tagline: PropTypes.string
  }),
  unimprovedValue: PropTypes.string,
  floor: PropTypes.string,
  previewHeightMobile: PropTypes.number,
  previewHeightDesktop: PropTypes.number,
  agencyLogos: PropTypes.arrayOf(PropTypes.string),
  onAddToWatchlist: PropTypes.func,
  onResizeFinished: PropTypes.func
}, MediaQueryProvider.childContextTypes), {}, {
  enableWatchlistButton: PropTypes.bool,
  media: PropTypes.shape({}),
  scrollToAuction: PropTypes.func,
  children: PropTypes.node,
  preDescription: PropTypes.node,
  clientRenderedDescription: PropTypes.bool
});
AllhomesListingSummary.defaultProps = {
  title: undefined,
  additionalPropertyTypes: [],
  appearance: PropertyIdentifierAppearance.RESIDENTIAL,
  price: undefined,
  priceGuide: undefined,
  description: '',
  sizes: {},
  unimprovedValue: '',
  floor: '',
  previewHeightMobile: 65,
  previewHeightDesktop: 150,
  media: {},
  enableWatchlistButton: true,
  agencyLogos: [],
  development: {},
  onResizeFinished: () => {},
  onAddToWatchlist: () => {},
  scrollToAuction: () => {},
  children: undefined,
  preDescription: undefined,
  clientRenderedDescription: true
};
export default withMedia(withEventBoundary('summary')(AllhomesListingSummary));
export { AllhomesListingSummary as BaseAllhomesListingSummary };